/**
 * Mulberry32: PRNG determinístico con seed.
 * Útil para combate replicable y para generar el offset de obfuscación.
 */
export function createRng(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Entero aleatorio en [min, max] inclusive usando un rng dado.
 */
export function randInt(rng: () => number, min: number, max: number): number {
  return Math.floor(rng() * (max - min + 1)) + min;
}

/**
 * Tirada de dado para checks del juego: 1d20 + modificador vs DC.
 * Usado en combate y en tests de stat.
 */
export function rollCheck(
  rng: () => number,
  modifier: number,
  difficulty: number,
): { total: number; roll: number; success: boolean; critical: 'hit' | 'miss' | null } {
  const roll = randInt(rng, 1, 20);
  const total = roll + modifier;
  const critical = roll === 20 ? 'hit' : roll === 1 ? 'miss' : null;
  const success = critical === 'hit' ? true : critical === 'miss' ? false : total >= difficulty;
  return { total, roll, success, critical };
}
